export enum Transition {
  fast = "0.1s ease",
  hover = "0.25s ease",
  medium = "0.3s ease",
  slow = "0.5s ease",
  turtle = "2s ease",
}
